import React from "react"
import styled, { css } from "styled-components"
import IconTitleCard from "../molecules/icon-title-card"
import VariantContainer from "../atoms/variant-container"
import { T } from "../atoms/text"

const IconContactGrid = ({ items }) => {
  return (
    <>
      <VariantContainer
        variants={[
          css`
            display: grid;
            grid-template-columns: 1fr;
            grid-column: 2 / -1;
            grid-gap: 24px;
          `,
          css`
            grid-column: 2 / -2;
            grid-template-columns: 1fr 1fr;
            grid-gap: 32px;
            align-self: center;
          `,
          css`
            grid-column: 7 / -1;
            grid-row: 1 / 4;
            margin-top: 0;
          `,
        ]}
      >
        {items.map((item) => (
          <IconTitleCard
            icon={item.icon}
            title={item.title}
            descriptionVariants={[{ margin: "0" }]}
            titleVariants={[
              css`
                ${T.lg.subheading`500`}
                color: var(--dark-mode-body-grey);
                text-align: left;
                align-items: center;
              `,
              css`
                ${T.lg.subheading`500`}
                text-align: left;
              `,
              css`
                ${T.lg.subheading`500`}
                text-align: left;
              `,
            ]}
            iconVariants={{
              sm: { width: "32px", height: "32px" },
            }}
          />
        ))}
      </VariantContainer>
    </>
  )
}

export default styled(IconContactGrid)``
